export const ONBOARD = {
  EMAIL_VERIFICATION: `/onboard/send-otp/by-email`,
  OTP_VERIFICATION: `/onboard/verify-otp`,
  PACKAGE_LIST: `/webmanza-payment/get-packages-webmanza`,
  STORE_CREATE: `/onboard/store/open-store-create`,
  ACQUIRE_PAYMENT: `/webmanza-payment/acquire-chargeUrl-webmanza`,
  PAYMENT_SUCCESS: `/webmanza-payment/check-payment-webmanza`,
}
